export default function CircleNumberCheckbox({ label, handleCheck, data }) {
    const isActive = data[label];
    return (
        <div
            className={`${isActive ? "!bg-[#009639] text-white" : ""} transition-all duration-200 ease-in-out flex justify-center items-center mx-1 w-7 h-7 border border-solid border-gray-400 rounded-full bg-white`}
            onClick={(label) => handleCheck(label)}
        >
            {label}
        </div>
    )
}